export default __webpack_public_path__ + "3c9afd296d6f47c594b91252a6b7b58f.mp4";